export default class CardService {

  static getCards() {
  }

  static getDefaultCard(cards) {
    return cards[0];
  }
}
